"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = __importDefault(require("react-dom/client"));
const react_router_dom_1 = require("react-router-dom");
const AppWrapper_1 = require("./AppWrapper");
const el = document.createElement('div');
document.body.appendChild(el);
const root = client_1.default.createRoot(document.getElementById('root'));
root.render((0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { basename: "/", children: (0, jsx_runtime_1.jsx)(AppWrapper_1.AppWrapper, {}) }));
